import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SubmitAuthService {
  submit = false;

  canSubmit(): boolean {
    return this.submit;
  }

  setCanSubmit(value:boolean): void {
    this.submit = value;
  }
}
